export default "__VITE_ASSET__38uIpnMg__"